var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.advertisement)?_c('app-button',{on:{"click":_vm.exec}},[_vm._t("default",[_vm._v("プレビュートークンの発行")])],2):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }